import { TextInput, Text, TextInputProps } from "@mantine/core"
import {
  getCurrencySymbol,
  formatThousandsSeparator,
  parseUserInput,
} from "@/utils/get-formatted-number"

interface PriceInputProps extends Omit<TextInputProps, "onChange"> {
  value: string
  onChange: (cleanedInput: string, numValue: number | undefined) => void
  onBlur?: () => void
  currency?: string
}

export function PriceInput({
  value,
  onChange,
  onBlur,
  currency = "EUR",
  placeholder = "0,00",
  ...props
}: PriceInputProps) {
  const handleChange = (inputValue: string) => {
    let cleanedInput = ""
    let commaAdded = false

    for (let char of inputValue) {
      if (char >= "0" && char <= "9") {
        cleanedInput += char
      } else if (char === "," && !commaAdded) {
        cleanedInput += ","
        commaAdded = true
      }
    }

    const numValue = parseUserInput(cleanedInput)
    onChange(cleanedInput, numValue)
  }

  const handleBlur = () => {
    const formatted = formatThousandsSeparator(value)
    const numValue = parseUserInput(value)
    onChange(formatted, numValue)
    onBlur?.()
  }

  return (
    <TextInput
      value={value}
      onChange={(e) => handleChange(e.currentTarget.value)}
      onBlur={handleBlur}
      placeholder={placeholder}
      rightSection={<Text c="dimmed">{getCurrencySymbol(currency)}</Text>}
      {...props}
    />
  )
}
